function textValue(value){return String(value||'').trim();}

function optionalNumber(value){
  const raw=textValue(value);
  return raw===''?null:Number(raw);
}

function sourceMap(catalogue=[],customProducts=[]){
  const map=new Map();
  for(const item of catalogue||[]){
    const code=textValue(item?.code);
    if(!code)continue;
    const label=textValue(item?.displayName||item?.labels?.pl||item?.displayNamePl||code);
    map.set('catalogue:'+code,Object.freeze({
      catalogueProductCode:code,
      customProductId:null,
      nameSnapshot:label
    }));
  }
  for(const item of customProducts||[]){
    if(item?.archivedAt)continue;
    const id=textValue(item?.id);
    if(!id)continue;
    map.set('custom:'+id,Object.freeze({
      catalogueProductCode:null,
      customProductId:id,
      nameSnapshot:textValue(item?.name)
    }));
  }
  return map;
}

export function smokingItemInputFromForm(formData,{catalogue=[],customProducts=[]}={}){
  if(!formData?.get)throw new TypeError('FormData-like input is required');
  const key=textValue(formData.get('productSource'));
  const source=sourceMap(catalogue,customProducts).get(key);
  if(!source)throw new TypeError('Select a valid product');

  const mass=optionalNumber(formData.get('mass'));
  const massUnit=mass==null?null:textValue(formData.get('massUnit')).toLowerCase()||null;
  const quantity=optionalNumber(formData.get('quantity'));

  return Object.freeze({
    ...source,
    quantity,
    mass,
    massUnit
  });
}
